import * as types from '../mutation-types';
import { Module } from 'vuex';
import api from '../../api/modules/podcasts';

interface State {
  podcasts: PodcastResponse[] | null;
  studioPodcasts: PodcastResponse[] | null;
}

const initialState: State = {
  podcasts: [],
  studioPodcasts: [],
};

const podcastsModule: Module<State, any> = {
  namespaced: true,
  state: initialState,
  getters: {
    podcasts: state => state.podcasts,
  },
  actions: {
    async loadPodcasts({ commit, state }) {
      commit(types.SET_PODCASTS, []);
      const groups = await api.getPodcasts();
      commit(types.SET_PODCASTS, groups);
      return state.podcasts;
    },
    async loadStudioPodcasts({ commit, state }, { studioURL }) {
      return await api.loadStudioPodcasts(studioURL);
    },
    async loadStudioPodcast({ commit, state }, { studioURL, podcastId }) {
      return await api.loadStudioPodcast(studioURL, podcastId);
    },
    async loadStudioRecentEpisodes({ commit, state }, { studioURL }) {
      return await api.loadStudioRecentEpisodes(studioURL);
    },
    async getPodcast(_, podcastId: number) {
      return await api.getPodcast(podcastId);
    },
    async deletePodcast(_, podcastId: number) {
      return await api.deletePodcast(podcastId);
    },
    async addPodcast(_, podcast: PodcastResponse) {
      return await api.createPodcast(podcast);
    },
    async editPodcast(_, podcast) {
      return await api.updatePodcast(podcast);
    },
    async setPodcastActiveFlag(_, { podcastId, active }) {
      return await api.setPodcastActiveFlag(podcastId, active);
    },
    async getPodcastEpisodes(_, podcastId: number) {
      return await api.getPodcastEpisodes(podcastId);
    },
    async getPodcastEpisode(_, { podcastId, episodeId }) {
      return await api.getPodcastEpisode(podcastId, episodeId);
    },
    async addPodcastEpisode(_, { podcastId, episode }) {
      return await api.addPodcastEpisode(podcastId, episode);
    },
    async updatePodcastEpisode(_, { podcastId, episode }) {
      return await api.updatePodcastEpisode(podcastId, episode);
    },
    async publishPodcastEpisode(_, { podcastId, episodeId }) {
      return await api.publishPodcastEpisode(podcastId, episodeId);
    },
    async deletePodcastEpisode(_, { podcastId, episodeId }) {
      return await api.deletePodcastEpisode(podcastId, episodeId);
    },
    async reorderEpisodes({ commit, dispatch }, { podcastId, episodes }) {
      await Promise.all(
        episodes.forEach(episode =>
          dispatch('updatePodcastEpisode', { podcastId, episode })
        )
      );
    },
    async loadMembers(_, { podcastId, q, page }) {
      return await api.loadMembers(podcastId, q, page);
    },
    banMember(_, { podcastId, memberId }) {
      return api.banMember(podcastId, memberId);
    },
    unBanMember(_, { podcastId, memberId }) {
      return api.unBanMember(podcastId, memberId);
    },
  },
  mutations: {
    [types.SET_PODCASTS](state: State, podcasts: PodcastResponse[]) {
      state.podcasts = podcasts;
    },
  },
};
export default podcastsModule;
